import actionCreatorFactory from 'typescript-fsa'
import { QueryType } from './types'

const actionCreator = actionCreatorFactory()

export const ActressesActions = {
  searchActresses: actionCreator.async<QueryType, void>('SEARCH_ACTRESSES')
}
